import _isUndefined from "lodash/isUndefined";

/**
 * 文件相关
 * @date: 2019-12-25
 * @author: wjc <jiacheng.wang@hand-china.com>
 * @version: 0.0.1
 * @copyright Copyright (c) 2018, Hand
 */
import qs from 'query-string';
import { getEnvConfig } from "../iocUtils";
import { HZERO_FILE } from "../config";
import { filterNullValueObject, getRequestId } from "./common";
import { getAccessToken } from "./token";
import { getCurrentOrganizationId, isTenantRoleLevel } from "./user";
/**
 * 通过文件服务器的接口获取可访问的文件URL
 *
 * @export
 * @param {String} url 上传接口返回的 Url
 * @param {String} bucketName 桶名
 * @param {Number} tenantId 租户Id
 * @param {String} bucketDirectory 文件目录
 * @param {String} storageCode 存储配置编码
 */
// @ts-ignore

export function getAttachmentUrl(url, bucketName, tenantId, bucketDirectory, storageCode) {
  var redirectDownload = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var accessToken = getAccessToken();
  var requestId = getRequestId();
  var params = qs.stringify(filterNullValueObject({
    bucketName: bucketName,
    storageCode: storageCode,
    access_token: accessToken,
    'H-Request-Id': requestId,
    directory: bucketDirectory
  }));
  var _getEnvConfig = getEnvConfig(),
    uploadRedirectDownload = _getEnvConfig.configureParams.uploadRedirectDownload;
  if (!redirectDownload || !_isUndefined(uploadRedirectDownload) && !uploadRedirectDownload) {
    var newUrl = !isTenantRoleLevel() ? "".concat(HZERO_FILE, "/v1/files/download-by-url?").concat(params, "&url=").concat(encodeURIComponent(url)) : "".concat(HZERO_FILE, "/v1/").concat(getCurrentOrganizationId(), "/files/download-by-url?").concat(params, "&url=").concat(encodeURIComponent(url));
    return newUrl;
  } else {
    var _newUrl = !isTenantRoleLevel() ? "".concat(HZERO_FILE, "/v1/files/download?").concat(params, "&url=").concat(encodeURIComponent(url)) : "".concat(HZERO_FILE, "/v1/").concat(getCurrentOrganizationId(), "/files/download?").concat(params, "&url=").concat(encodeURIComponent(url));
    return _newUrl;
  }
}